import React from "react";

import appConfig from "config/appConfig";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useUser } from "shared/hooks";

interface SecureRouteProps {
	roles?: any[];
}

const SecureRoute: React.FC<SecureRouteProps> = () => {
	const { pathname, search } = useLocation();

	const { getData: getUserData } = useUser();
	const { isAuthorized } = getUserData();

	if (!isAuthorized) {
		const query = new URLSearchParams("");
		query.set("redirectUrl", encodeURIComponent(`${pathname}${search}`));

		return (
			<Navigate
				to={{
					pathname: appConfig.CORE_URLS.HOME,
					search: query.toString()
				}}
				replace
			/>
		);
	}

	return <Outlet />;
};

export default SecureRoute;
